import { useRecoilValue } from "recoil";
import { setRecoil } from "recoil-nexus";
import LogController from "../../../controller/LogController";
import { cartProductQuantityState, cartState } from "../../../recoil/cart";
import {
  csChatListState,
  newChatListState,
  selectChatState,
} from "../../../recoil/chat";
import { langState } from "../../../recoil/lang";
import { FooterButtonProps } from "./type";
import { conciergeState } from "../../../recoil/socket";

export const useFooterButton = (props: FooterButtonProps) => {
  const lang = useRecoilValue(langState);

  const cart = useRecoilValue(cartState);
  const cartQuantitiy = useRecoilValue(cartProductQuantityState);

  const newChatListFlag = useRecoilValue(newChatListState);
  const csChatListFlag = useRecoilValue(csChatListState);
  const conciergeFlag = useRecoilValue(conciergeState);

  // cart 이동
  const handleCartClick = () => {
    if (cart.length > 0) {
      props.navigateAdStore(cart[0].store_id);
      LogController.click({
        path: "StoreSelector(MainPage)",
        params: "click",
        params2: "장바구니 버튼 클릭",
      });
    }
  };

  const handleCustomerServiceClick = () => {
    setRecoil(selectChatState, true);
    LogController.click({
      path: "StoreSelector(MainPage)",
      params: "click",
      params2: "긴급요청 버튼 클릭",
    });
  };

  const conciergeCheck = () => {
    if (props.concierge?.concierge_manage?.status === 1) {
      if (props.concierge.concierge_manage.is_concierge_time_set === 0)
        return true;
      else {
        const nowDate = new Date();
        const currentMin = nowDate.getHours() * 60 + nowDate.getMinutes();

        const conciergeStartTime = props.concierge.concierge_manage.start_time
          .split(":")
          .map(Number);
        const startMin = conciergeStartTime[0] * 60 + conciergeStartTime[1];

        const conciergeEndTime = props.concierge.concierge_manage.end_time
          .split(":")
          .map(Number);
        const endMin = conciergeEndTime[0] * 60 + conciergeEndTime[1];

        console.log("time", currentMin, startMin, endMin);

        if (startMin === endMin) {
          return true;
        }

        if (startMin < endMin) {
          return currentMin >= startMin && currentMin < endMin;
        } else {
          return currentMin >= startMin || currentMin < endMin;
        }
      }
    } else if (conciergeFlag.concierge_id) {
      return true;
    } else return false;
  };

  const interphoneCheck = () => {
    return props.interphoneAreaList.length > 0 && props.useInterphone === 1;
  };

  const handleConciergeClick = () => {
    if (conciergeFlag.concierge_id) {
      setRecoil(conciergeState, { ...conciergeFlag, isChat: true });
    } else {
      props.openConciergeModal();
    }
    LogController.click({
      path: "StoreSelector(MainPage)",
      params: "click",
      params2: "프론트요청 버튼 클릭",
    });
  };

  return {
    lang,
    cart,
    cartQuantitiy,
    newChatListFlag,
    csChatListFlag,
    handleCartClick,
    handleCustomerServiceClick,
    conciergeCheck,
    interphoneCheck,
    handleConciergeClick,
  };
};
